import config from "@/config";
import http from "@/utils/request";

export default {
	menu: {
		myMenus: {
			url: `${config.API_URL}/system/menu/my/1.6.1`,
			name: "获取我的菜单",
			get: async function () {
				//var result = await http.get(this.url);
				

				var result = {
					code: 200,
					message: "",
					data: {
						menu: [
							{
								name: "home",
								path: "/home",
								meta: {
									title: "首页",
									icon: "el-icon-eleme-filled",
									type: "menu",
									keepAlive: true,
								},
								children: [
									{
										name: "dashboard",
										path: "/dashboard",
										meta: {
											title: "控制台",
											icon: "el-icon-menu",
											affix: true,
											keepAlive: true,
										},
										component: "home",
									},
									{
										name: "userCenter",
										path: "/usercenter",
										meta: {
											title: "帐号信息",
											icon: "el-icon-user",
											tag: "NEW",
											keepAlive: true,
										},
										component: "userCenter",
									},
								],
							},
							{
								name: "vab",
								path: "/vab",
								meta: {
									title: "组件",
									icon: "el-icon-takeaway-box",
									type: "menu",
									keepAlive: true,
								},
								children: [
									{
										path: "/vab/mini",
										name: "minivab",
										meta: {
											title: "原子组件",
											icon: "el-icon-magic-stick",
											type: "menu",
											keepAlive: true,
										},
										component: "vab/mini",
									},
									{
										path: "/vab/iconfont",
										name: "iconfont",
										meta: {
											title: "扩展图标",
											icon: "el-icon-orange",
											type: "menu",
											keepAlive: true,
										},
										component: "vab/iconfont",
									},
									{
										path: "/vab/data",
										name: "vabdata",
										meta: {
											title: "Data 数据展示",
											icon: "el-icon-histogram",
											type: "menu",
											keepAlive: true,
										},
										children: [
											{
												path: "/vab/chart",
												name: "chart",
												meta: {
													title: "图表 Echarts",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/chart",
											},
											{
												path: "/vab/statistic",
												name: "statistic",
												meta: {
													title: "统计数值",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/statistic",
											},
											{
												path: "/vab/video",
												name: "scvideo",
												meta: {
													title: "视频播放器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/video",
											},
											{
												path: "/vab/qrcode",
												name: "qrcode",
												meta: {
													title: "二维码",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/qrcode",
											},
										],
									},
									{
										path: "/vab/form",
										name: "vabform",
										meta: {
											title: "Form 数据录入",
											icon: "el-icon-edit",
											type: "menu",
											keepAlive: true,
										},
										children: [
											{
												path: "/vab/tableselect",
												name: "tableselect",
												meta: {
													title: "表格选择器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/tableselect",
											},
											{
												path: "/vab/formtable",
												name: "formtable",
												meta: {
													title: "表单表格",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/formtable",
											},
											{
												path: "/vab/selectFilter",
												name: "selectFilter",
												meta: {
													title: "分类筛选器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/selectFilter",
											},
											{
												path: "/vab/filterbar",
												name: "filterBar",
												meta: {
													title: "过滤器v2",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/filterBar",
											},
											{
												path: "/vab/upload",
												name: "upload",
												meta: {
													title: "上传",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/upload",
											},
											{
												path: "/vab/select",
												name: "scselect",
												meta: {
													title: "异步选择器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/select",
											},
											{
												path: "/vab/iconselect",
												name: "iconSelect",
												meta: {
													title: "图标选择器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/iconselect",
											},
											{
												path: "/vab/cron",
												name: "cron",
												meta: {
													title: "Cron规则生成器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/cron",
											},
											{
												path: "/vab/editor",
												name: "editor",
												meta: {
													title: "富文本编辑器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/editor",
											},
											{
												path: "/vab/codeeditor",
												name: "codeeditor",
												meta: {
													title: "代码编辑器",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/codeeditor",
											},
										],
									},
									{
										path: "/vab/feedback",
										name: "vabfeedback",
										meta: {
											title: "Feedback 反馈",
											icon: "el-icon-mouse",
											type: "menu",
											keepAlive: true,
										},
										children: [
											{
												path: "/vab/drag",
												name: "drag",
												meta: {
													title: "拖拽排序",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/drag",
											},
											{
												path: "/vab/contextmenu",
												name: "contextmenu",
												meta: {
													title: "右键菜单",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/contextmenu",
											},
											{
												path: "/vab/cropper",
												name: "cropper",
												meta: {
													title: "图像剪裁",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/cropper",
											},
											{
												path: "/vab/fileselect",
												name: "fileselect",
												meta: {
													title: "资源库选择器(弃用)",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/fileselect",
											},
											{
												path: "/vab/dialog",
												name: "dialogExtend",
												meta: {
													title: "弹窗扩展",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/dialog",
											},
										],
									},
									{
										path: "/vab/others",
										name: "vabothers",
										meta: {
											title: "Others 其他",
											icon: "el-icon-more-filled",
											type: "menu",
											keepAlive: true,
										},
										children: [
											{
												path: "/vab/print",
												name: "print",
												meta: {
													title: "打印",
													type: "menu",
													keepAlive: true,
												},
												component: "vab/print",
											},
											{
												path: "/vab/watermark",
												name: "watermark",
												meta: {
													title: "水印",
													type: "menu",
												},
												component: "vab/watermark",
											},
											{
												path: "/vab/importexport",
												name: "importexport",
												meta: {
													title: "文件导出导入",
													type: "menu",
												},
												component: "vab/importexport",
											},
										],
									},
									{
										path: "/vab/list",
										name: "list",
										meta: {
											title: "Table 数据列表",
											icon: "el-icon-fold",
											type: "menu",
										},
										children: [
											{
												path: "/vab/table/base",
												name: "tableBase",
												meta: {
													title: "基础数据列表",
													type: "menu",
												},
												component: "vab/table/base",
											},
											{
												path: "/vab/table/thead",
												name: "tableThead",
												meta: {
													title: "多级表头",
													type: "menu",
												},
												component: "vab/table/thead",
											},
											{
												path: "/vab/table/column",
												name: "tableCustomColumn",
												meta: {
													title: "动态列",
													type: "menu",
												},
												component: "vab/table/column",
											},
											{
												path: "/vab/table/remote",
												name: "tableRemote",
												meta: {
													title: "远程排序过滤",
													type: "menu",
												},
												component: "vab/table/remote",
											},
										],
									},
									{
										path: "/vab/workflow",
										name: "workflow",
										meta: {
											title: "工作流设计器",
											icon: "el-icon-share",
											type: "menu",
										},
										component: "vab/workflow",
									},
									{
										path: "/vab/formrender",
										name: "formRender",
										meta: {
											title: "动态表单(Beta)",
											icon: "el-icon-message-box",
											type: "menu",
										},
										component: "vab/form",
									},
								],
							},
							{
								name: "template",
								path: "/template",
								meta: {
									title: "模板",
									icon: "el-icon-files",
									type: "menu",
								},
								children: [
									{
										path: "/template/layout",
										name: "layoutTemplate",
										meta: {
											title: "布局",
											icon: "el-icon-grid",
											type: "menu",
										},
										children: [
											{
												path: "/template/layout/blank",
												name: "blank",
												meta: {
													title: "空白模板",
													type: "menu",
												},
												component:
													"template/layout/blank",
											},
											{
												path: "/template/layout/layoutTCB",
												name: "layoutTCB",
												meta: {
													title: "上中下布局",
													type: "menu",
												},
												component:
													"template/layout/layoutTCB",
											},
											{
												path: "/template/layout/layoutLCR",
												name: "layoutLCR",
												meta: {
													title: "左中右布局",
													type: "menu",
												},
												component:
													"template/layout/layoutLCR",
											},
										],
									},
									{
										path: "/template/list",
										name: "list",
										meta: {
											title: "列表",
											icon: "el-icon-document",
											type: "menu",
										},
										children: [
											{
												path: "/template/list/crud",
												name: "listCrud",
												meta: {
													title: "CRUD",
													type: "menu",
												},
												component: "template/list/crud",
												children: [
													{
														path: "/template/list/crud/detail/:id?",
														name: "listCrud-detail",
														meta: {
															title: "新增/编辑",
															hidden: true,
															active: "/template/list/crud",
															type: "menu",
														},
														component:
															"template/list/crud/detail",
													},
												],
											},
											{
												path: "/template/list/tree",
												name: "listTree",
												meta: {
													title: "左树右表",
													type: "menu",
												},
												component: "template/list/tree",
											},
											{
												path: "/template/list/tab",
												name: "listTab",
												meta: {
													title: "分类表格",
													type: "menu",
												},
												component: "template/list/tab",
											},
											{
												path: "/template/list/son",
												name: "listSon",
												meta: {
													title: "子母表",
													type: "menu",
												},
												component: "template/list/son",
											},
											{
												path: "/template/list/widthlist",
												name: "widthlist",
												meta: {
													title: "定宽列表",
													type: "menu",
												},
												component:
													"template/list/width",
											},
										],
									},
									{
										path: "/template/other",
										name: "other",
										meta: {
											title: "其他",
											icon: "el-icon-folder",
											type: "menu",
										},
										children: [
											{
												path: "/template/other/stepform",
												name: "stepform",
												meta: {
													title: "分步表单",
													type: "menu",
												},
												component:
													"template/other/stepform",
											},
										],
									},
								],
							},
							{
								name: "other",
								path: "/other",
								meta: {
									title: "其他",
									icon: "el-icon-more-filled",
									type: "menu",
								},
								children: [
									{
										path: "/other/directive",
										name: "directive",
										meta: {
											title: "指令",
											icon: "el-icon-price-tag",
											type: "menu",
										},
										component: "other/directive",
									},
									{
										path: "/other/viewTags",
										name: "viewTags",
										meta: {
											title: "标签操作",
											icon: "el-icon-files",
											type: "menu",
										},
										component: "other/viewTags",
										children: [
											{
												path: "/other/fullpage",
												name: "fullpage",
												meta: {
													title: "整页路由",
													icon: "el-icon-monitor",
													fullpage: true,
													hidden: true,
													type: "menu",
												},
												component: "other/fullpage",
											},
										],
									},
									{
										path: "/other/verificate",
										name: "verificate",
										meta: {
											title: "表单验证",
											icon: "el-icon-open",
											type: "menu",
										},
										component: "other/verificate",
									},
									{
										path: "/other/loadJS",
										name: "loadJS",
										meta: {
											title: "异步加载JS",
											icon: "el-icon-location-information",
											type: "menu",
										},
										component: "other/loadJS",
									},
									{
										path: "/link",
										name: "link",
										meta: {
											title: "外部链接",
											icon: "el-icon-link",
											type: "menu",
										},
										children: [
											{
												path: "https://baidu.com",
												name: "百度",
												meta: {
													title: "百度",
													type: "link",
												},
											},
											{
												path: "https://www.google.cn",
												name: "谷歌",
												meta: {
													title: "谷歌",
													type: "link",
												},
											},
										],
									},
									{
										path: "/iframe",
										name: "Iframe",
										meta: {
											title: "Iframe",
											icon: "el-icon-position",
											type: "menu",
										},
										children: [
											{
												path: "https://v3.cn.vuejs.org",
												name: "vue3",
												meta: {
													title: "VUE 3",
													type: "iframe",
												},
											},
											{
												path: "https://element-plus.gitee.io",
												name: "elementplus",
												meta: {
													title: "Element Plus",
													type: "iframe",
												},
											},
											{
												path: "https://lolicode.gitee.io/scui-doc",
												name: "scuidoc",
												meta: {
													title: "SCUI文档",
													type: "iframe",
												},
											},
										],
									},
								],
							},
							{
								name: "test",
								path: "/test",
								meta: {
									title: "实验室",
									icon: "el-icon-mouse",
									type: "menu",
								},
								children: [
									{
										path: "/test/autocode",
										name: "autocode",
										meta: {
											title: "代码生成器",
											icon: "sc-icon-code",
											type: "menu",
										},
										component: "test/autocode/index",
										children: [
											{
												path: "/test/autocode/table",
												name: "autocode-table",
												meta: {
													title: "CRUD代码生成",
													hidden: true,
													active: "/test/autocode",
													type: "menu",
												},
												component:
													"test/autocode/table",
											},
										],
									},
									{
										path: "/test/codebug",
										name: "codebug",
										meta: {
											title: "异常处理",
											icon: "sc-icon-bug-line",
											type: "menu",
										},
										component: "test/codebug",
									},
								],
							},
							{
								name: "setting",
								path: "/setting",
								meta: {
									title: "配置",
									icon: "el-icon-setting",
									type: "menu",
								},
								children: [
									{
										path: "/setting/system",
										name: "system",
										meta: {
											title: "系统设置",
											icon: "el-icon-tools",
											type: "menu",
										},
										component: "setting/system",
									},
									{
										path: "/setting/user",
										name: "user",
										meta: {
											title: "用户管理",
											icon: "el-icon-user-filled",
											type: "menu",
										},
										component: "setting/user",
									},
									{
										path: "/setting/role",
										name: "role",
										meta: {
											title: "角色管理",
											icon: "el-icon-notebook",
											type: "menu",
										},
										component: "setting/role",
									},
									{
										path: "/setting/dept",
										name: "dept",
										meta: {
											title: "部门管理",
											icon: "sc-icon-organization",
											type: "menu",
										},
										component: "setting/dept",
									},
									{
										path: "/setting/dic",
										name: "dic",
										meta: {
											title: "字典管理",
											icon: "el-icon-document",
											type: "menu",
										},
										component: "setting/dic",
									},
									{
										path: "/setting/table",
										name: "tableSetting",
										meta: {
											title: "表格列管理",
											icon: "el-icon-scale-to-original",
											type: "menu",
										},
										component: "setting/table",
									},
									{
										path: "/setting/menu",
										name: "settingMenu",
										meta: {
											title: "菜单管理",
											icon: "el-icon-fold",
											type: "menu",
										},
										component: "setting/menu",
									},
									{
										path: "/setting/task",
										name: "task",
										meta: {
											title: "计划任务",
											icon: "el-icon-alarm-clock",
											type: "menu",
										},
										component: "setting/task",
									},
									{
										path: "/setting/client",
										name: "client",
										meta: {
											title: "应用管理",
											icon: "el-icon-help-filled",
											type: "menu",
										},
										component: "setting/client",
									},
									{
										path: "/setting/log",
										name: "log",
										meta: {
											title: "系统日志",
											icon: "el-icon-warning",
											type: "menu",
										},
										component: "setting/log",
									},
								],
							},
							{
								path: "/other/about",
								name: "about",
								meta: {
									title: "关于",
									icon: "el-icon-info-filled",
									type: "menu",
								},
								component: "other/about",
							},
						],
						permissions: [
							"list.add",
							"list.edit",
							"list.delete",
							"user.add",
							"user.edit",
							"user.delete",
						],
						dashboardGrid: [
							"welcome",
							"ver",
							"time",
							"progress",
							"echarts",
							"about",
						],
					},
				};
				return result;
			},
		},
		list: {
			url: `${config.API_URL}/system/menu/list`,
			name: "获取菜单",
			get: async function () {
				//var result = await http.get(this.url);
				

				var result = {
					code: 200,
					message: "",
					data: [
						{
							id: "00001",
							parentId: null,
							name: "system",
							path: "/system",
							meta: {
								title: "系统",
								icon: "el-icon-setting",
								type: "menu",
							},
							apiList: [
								{
									code: "system.list",
									url: "/api/system/list",
								},
							],
							component: "",
							children: [
								{
									id: "00001001",
									parentId: "00001",
									name: "user",
									path: "/system/user",
									meta: {
										title: "用户管理",
										icon: "el-icon-setting",
										type: "menu",
									},
									component: "",
									children: [
										{
											id: "00001001001",
											parentId: "00001001",
											name: "user.add",
											meta: {
												title: "新增",
												type: "button",
											},
										},
										{
											id: "00001001002",
											parentId: "00001001",
											name: "user.edit",
											meta: {
												title: "编辑",
												type: "button",
											},
										},
										{
											id: "00001001003",
											parentId: "00001001",
											name: "user.del",
											meta: {
												title: "删除",
												type: "button",
											},
										},
									],
								},
							],
						},
						{
							id: "00002",
							parentId: null,
							name: "other",
							path: "/other",
							meta: {
								title: "其他",
								icon: "el-icon-more",
								type: "menu",
							},
							component: "",
							children: [
								{
									id: "00002001",
									parentId: "00002",
									name: "directive",
									path: "/other/directive",
									meta: {
										title: "指令",
										icon: "el-icon-price-tag",
										type: "menu",
									},
									component: "",
									children: [
										{
											id: "00002001001",
											parentId: "00002001",
											name: "directive.add",
											meta: {
												title: "新增",
												type: "button",
											},
										},
										{
											id: "00002001002",
											parentId: "00002001",
											name: "directive.edit",
											meta: {
												title: "编辑",
												type: "button",
											},
										},
										{
											id: "00002001003",
											parentId: "00002001",
											name: "directive.del",
											meta: {
												title: "删除",
												type: "button",
											},
										},
									],
								},
							],
						},
					],
				};
				return result;
			},
		},
	},
	dic: {
		tree: {
			url: `${config.API_URL}/system/dic/tree`,
			name: "获取字典树",
			get: async function () {
				//var result = await http.get(this.url);
				

				var result = {
					code: 200,
					message: "",
					data: [
						{
							id: "1",
							code: "notice",
							name: "通知类型",
						},
						{
							id: "2",
							code: "sex",
							name: "性别",
						},
						{
							id: "3",
							code: "menuCategory",
							name: "菜单类型",
						},
						{
							id: "4",
							code: "userType",
							name: "用户类型",
							children: [
								{
									id: "41",
									code: "userTypePC",
									name: "Desktop",
								},
								{
									id: "42",
									code: "userTypeAPP",
									name: "Mobile",
								},
							],
						},
					],
				};
				return result;
			},
		},
		list: {
			url: `${config.API_URL}/system/dic/list`,
			name: "字典明细",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 3,
						page: 1,
						pageSize: 20,
						rows: [
							{
								id: "100",
								key: "1",
								name: "发布通知",
								dic: "1",
								yx: "1",
							},
							{
								id: "102",
								key: "2",
								name: "转发通知",
								dic: "1",
								yx: "1",
							},
							{
								id: "105",
								key: "3",
								name: "事务通知",
								dic: "1",
								yx: "0",
							},
						],
					},
				};
				return result;
			},
		},
		get: {
			url: `${config.API_URL}/system/dic/get`,
			name: "获取字典数据",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: [
						{
							value: "1",
							label: "发布通知",
						},
						{
							value: "2",
							label: "转发通知",
						},
						{
							value: "3",
							label: "事务通知",
						},
					],
				};
				return result;
			},
		},
	},
	role: {
		list: {
			url: `${config.API_URL}/system/role/list2`,
			name: "获取角色列表",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 2,
						page: 1,
						pageSize: 20,
						rows: [
							{
								id: "1",
								label: "超级管理员",
								alias: "SA",
								sort: 1,
								status: "1",
								remark: "内置超级管理员角色",
								date: "2020-05-07 09:30:00",
							},
							{
								id: "2",
								label: "业务管理员",
								alias: "Business Administrator",
								sort: 2,
								status: "1",
								remark: "",
								date: "2020-05-07 09:30:00",
							},
							{
								id: "3",
								label: "文章管理员",
								alias: "Article administrator",
								sort: 3,
								status: "0",
								remark: "",
								date: "2020-05-07 09:30:00",
							},
							{
								id: "4",
								label: "发布人员",
								alias: "publish",
								sort: 4,
								status: "1",
								remark: "",
								date: "2020-05-07 09:30:00",
							},
						],
					},
				};
				return result;
			},
		},
	},
	dept: {
		list: {
			url: `${config.API_URL}/system/dept/list`,
			name: "获取部门列表",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: [
						{
							id: "1",
							parentId: "0",
							label: "华南分部",
							date: "2022-10-10 08:00:00",
							remark: "",
							status: 1,
							sort: 1,
							children: [
								{
									id: "11",
									parentId: "1",
									label: "售前客服部",
									date: "2022-10-10 08:00:00",
									remark: "",
									status: 1,
									sort: 2,
								},
								{
									id: "12",
									parentId: "1",
									label: "技术研发部",
									date: "2022-10-10 08:00:00",
									remark: "软件开发&测试",
									status: 0,
									sort: 3,
								},
							],
						},
						{
							id: "2",
							parentId: "0",
							label: "华东分部",
							date: "2022-10-10 08:00:00",
							remark: "",
							status: 1,
							sort: 4,
							children: [
								{
									id: "21",
									parentId: "2",
									label: "售前客服部",
									date: "2022-10-10 08:00:00",
									remark: "",
									status: 1,
									sort: 5,
								},
								{
									id: "22",
									parentId: "2",
									label: "技术研发部",
									date: "2022-10-10 08:00:00",
									remark: "",
									status: 1,
									sort: 6,
								},
							],
						},
					],
				};
				return result;
			},
		},
	},
	user: {
		list: {
			url: `${config.API_URL}/system/user/list`,
			name: "获取用户列表",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 2,
						page: 1,
						pageSize: 20,
						summary: {
							id: "20",
							name: "999",
						},
						rows: [
							{
								id: "100",
								userName: "sakuya",
								avatar: "img/avatar.jpg",
								mail: "81883387@qq.com",
								name: "sakuya",
								group: ["1"],
								groupName: "超级管理员",
								dept: "11",
								date: "2021-10-10 12:00:00",
							},
							{
								id: "101",
								userName: "luhkpev",
								avatar: "img/avatar3.gif",
								mail: "k.luhkpev@zdgtfd.ma",
								name: "John Martinez",
								group: ["2", "4"],
								groupName: "业务管理员,发布人员",
								dept: "22",
								date: "2021-02-21 14:21:48",
							},
						],
					},
				};

				return result;
			},
		},
	},
	app: {
		list: {
			url: `${config.API_URL}/system/app/list`,
			name: "应用列表",
			get: async function () {
				//var result = await http.get(this.url);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 2,
						page: 1,
						pageSize: 20,
						rows: [
							{
								id: "100",
								appName: "自助机",
								appId: "selfHelp",
								secret: "YuOju6lP3t4thLbZOhRSV4UZ79vdnwIC",
								type: ["ALL"],
								exp: "2035-01-01 00:00:00",
							},
							{
								id: "101",
								appName: "微信小程序",
								appId: "WechatApp",
								secret: "WgBbsRtCeXiNXIYkkShxxvqOGrAYKK2e",
								type: ["UPDATA", "QUERY"],
								exp: "2023-06-01 00:00:00",
							},
						],
					},
				};
				return result;
			},
		},
	},
	log: {
		list: {
			url: `${config.API_URL}/system/log/list`,
			name: "日志列表",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 85060,
						page: 1,
						pageSize: 20,
						rows: [
							{
								id: "140000201003086826",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "158.100.230.241",
								user: "萧洋",
								time: "2004-12-27 10:49:11",
							},
							{
								id: "630000201101024844",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "200",
								cip: "191.144.108.120",
								user: "熊霞",
								time: "1986-09-09 03:13:17",
							},
							{
								id: "430000201004111850",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "200",
								cip: "109.195.17.110",
								user: "卢伟",
								time: "1996-11-01 02:21:47",
							},
							{
								id: "620000201005041722",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "75.92.108.185",
								user: "钱勇",
								time: "1974-07-26 01:18:16",
							},
							{
								id: "210000197609078395",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "500",
								cip: "157.139.144.23",
								user: "吕敏",
								time: "1994-02-05 00:29:36",
							},
							{
								id: "350000198504255581",
								level: "info",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "246.56.108.225",
								user: "沈刚",
								time: "1970-06-11 12:44:36",
							},
							{
								id: "440000197301175263",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "401",
								cip: "222.248.6.211",
								user: "孟杰",
								time: "2002-01-29 15:32:04",
							},
							{
								id: "610000197511037186",
								level: "info",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "500",
								cip: "91.150.48.73",
								user: "田娜",
								time: "1992-11-25 22:40:58",
							},
							{
								id: "410000199612301013",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "222.170.115.220",
								user: "武洋",
								time: "2009-04-09 01:48:12",
							},
							{
								id: "450000200003087878",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "200",
								cip: "13.80.235.131",
								user: "宋秀英",
								time: "1992-02-29 22:26:09",
							},
							{
								id: "420000200205194852",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "65.32.60.92",
								user: "钱霞",
								time: "1972-09-20 03:57:04",
							},
							{
								id: "310000200005252389",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "130.165.52.188",
								user: "陆勇",
								time: "1977-10-03 09:34:48",
							},
							{
								id: "810000197104257779",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "500",
								cip: "72.106.58.205",
								user: "孙明",
								time: "1970-11-18 00:42:48",
							},
							{
								id: "140000200111025583",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "500",
								cip: "65.222.51.118",
								user: "马超",
								time: "1991-05-27 13:14:52",
							},
							{
								id: "640000200807195175",
								level: "error",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "401",
								cip: "60.195.89.196",
								user: "苏超",
								time: "1988-08-06 22:07:31",
							},
							{
								id: "230000201411025442",
								level: "info",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "200",
								cip: "246.144.215.14",
								user: "苏静",
								time: "1987-11-22 05:25:41",
							},
							{
								id: "320000199612165697",
								level: "info",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "200",
								cip: "97.12.179.24",
								user: "蒋磊",
								time: "1977-01-11 23:05:36",
							},
							{
								id: "330000199801177920",
								level: "info",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "247.177.213.179",
								user: "郝丽",
								time: "1972-04-23 18:49:03",
							},
							{
								id: "620000197905179779",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "POST",
								code: "500",
								cip: "37.133.247.207",
								user: "唐平",
								time: "2001-06-26 21:31:52",
							},
							{
								id: "220000197411210620",
								level: "warn",
								name: "用户登录",
								url: "/oauth/token",
								type: "GET",
								code: "500",
								cip: "211.25.254.209",
								user: "冯娜",
								time: "2006-02-13 15:21:28",
							},
						],
					},
				};
				return result;
			},
		},
	},
	table: {
		list: {
			url: `${config.API_URL}/system/table/list`,
			name: "表格列管理列表",
			get: async function (params) {
				console.log(params);
				//var result = await http.get(this.url, params);
				

				var result = {
					code: 200,
					message: "",
					data: {
						total: 2,
						page: 1,
						pageSize: 20,
						rows: [
							{
								id: "1",
								name: "用户列表",
								code: "userList",
							},
						],
					},
				};
				return result;
			},
		},
		info: {
			url: `${config.API_URL}/system/table/info`,
			name: "表格列管理详情",
			get: async function (params) {
				var result = await http.get(this.url, params);
				

				return result;
			},
		},
	},
	tasks: {
		list: {
			url: `${config.API_URL}/system/tasks/list`,
			name: "系统任务管理",
			get: async function (params) {
				var result = await http.get(this.url, params);
				

				return result;
			},
		},
	},
};
